export const BASE_URL = "https://concierge-api.fly.dev/v1/room/?place=";
export const PLACE_URL = "https://concierge-api.fly.dev/v1/hotel/public/";
export const PACKAGES_URL = "https://concierge-api.fly.dev/v1/package/?place=";
export const BASE_CDN = "https://concierge.fra1.cdn.digitaloceanspaces.com/";
export const EMAIL_URL = "https://api.upoui.com/v1/notifications/contact";
